<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <btn :disabled="visible" :class="['mr-2']" size="xs" @click="makeRipple" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" :title="$lang.showRipple">{{ $lang.showRipple }}</btn>
        </test-toolbar>
      </flex-col>
      <flex-col equal-height :span="6" md8 sm12 v-for="ripple in 32" :key="ripple">
        <card full-height>
          <card-text>
            <line-ripple :visible="visible" :height="`${ripple + 2}px`" :bg-color="$dark ? 'black' : 'gray'" :bg-color-lightness="$dark ? null : 200" :ripple-bg-color="$root.colors.primary" :ripple-bg-color-lightness="$root.colors.bgColorLightness" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageLineRipple',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    makeRipple () {
      this.visible = true
      setTimeout(() => {
        this.visible = false
      }, 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/line-ripple.vue